export default __webpack_public_path__ + "static/media/about.337e5b50.png";